import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
//import ImageWithBasePath from "../../core/img/imagewithbasebath";

import { PlusCircle } from "react-feather";

import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import Table from "../../core/pagination/datatable";
import AddUsers from "../../core/modals/usermanagement/addusers";
import EditUser from "../../core/modals/usermanagement/edituser";
import { deleteUser } from "../../service/ApiServices";

import axios from "axios";

const Users = () => {
  const [userData, setUserData] = useState([]);
  const [updateUser, setUpdateUser] = useState(""); //set the update user
  //let currentDate = new Date();  //Not work in UI

  // console.log(userData, "USER DATA ==== user.jsx")
  const storedUserData = localStorage.getItem("user");
  const userDataa = JSON.parse(storedUserData);
  const roleName = userDataa?.data.role.roleName;

  const handleUpdateUser = (record) => {
    setUpdateUser(record);
  };

  //delete user
  const deleteUserData = async (record) => {
    try {
      // console.log(record.key,"RECORD user.jsx")
      await deleteUser(record.key);
      const updatedUserData = userData.filter((user) => user !== record);
      // showConfirmationAlert(record);
      setUserData(updatedUserData);
    } catch (error) {
      console.error("Error deleting user:", error);
    }
  };

  const fetchUsers = async () => {
    try {
      const res = await axios.get("/user/allusers");
      const usersArray = res.data.data;
      if (!Array.isArray(usersArray)) {
        throw new Error("Data is not an array");
      }

      const transformedData = usersArray.map((user) => ({
        key: user._id, // _id is used as key
        username: user.name, // changed `name` → `username`
        email: user.email,
        role: user.role,
        phone: user.phone || "No data",
        createdon: user.createdAt || "No data", // you had `currentDate`, but that was not defined
        status: user.status || "No data",
        password: user.password,
        confirmPassword: user.password,
        description: user.description,
      }));
      setUserData(transformedData);
    } catch (error) {
      console.error("Error fetching data: ", error.message);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  const columns = [
    {
      title: "User Name",
      dataIndex: "username",
    },
    {
      title: "Phone",
      dataIndex: "phone",
    },
    {
      title: "Email",
      dataIndex: "email",
    },
    {
      title: "Role",
      dataIndex: ["role", "roleName"],
      key: "roleName",
    },
    {
      title: "Status",
      dataIndex: "status",
      render: (text) => (
        <div>
          {text === "Active" && (
            <span className="badge badge-linesuccess">{text}</span>
          )}
          {text === "Inactive" && (
            <span className="badge badge-linedanger">{text}</span>
          )}
        </div>
      ),
      sorter: (a, b) => a.status.length - b.status.length,
    },
    {
      title: "Actions",
      dataIndex: "actions",
      key: "actions",
      render: (text, record) => (
        <td className="action-table-data">
          <div className="edit-delete-action">
            {roleName === "Admin" && (
              <Link
                className="me-2 p-2"
                to="#"
                onClick={() => {
                  Swal.fire({
                    title: "User Details",
                    html: `
                    <div style="text-align: left">
                      <p><strong>Name:</strong> ${record.username}</p>
                      <p><strong>Email:</strong> ${record.email}</p>
                      <p><strong>Phone:</strong> ${record.phone}</p>
                      <p><strong>Role:</strong> ${record.role.roleName}</p>
                      <p><strong>Status:</strong> ${record.status}</p>
                      <p><strong>Description:</strong> ${
                        record.description || "No description available"
                      }</p>
                    </div>
                  `,
                    confirmButtonText: "Close",
                  });
                }}
              >
                <i
                  data-feather="eye"
                  className="feather feather-eye action-eye"
                ></i>
              </Link>
            )}
            {roleName === "Admin" && (
              <Link
                className="me-2 p-2"
                to="#"
                data-bs-toggle="modal"
                data-bs-target="#edit-units"
                onClick={() => handleUpdateUser(record)}
              >
                <i data-feather="edit" className="feather-edit"></i>
              </Link>
            )}
            {roleName === "Admin" && (
              <Link className="confirm-text p-2" to="#">
                <i
                  data-feather="trash-2"
                  className="feather-trash-2"
                  onClick={() => showConfirmationAlert(record)}
                ></i>
              </Link>
            )}
          </div>
        </td>
      ),
    },
  ];
  const MySwal = withReactContent(Swal);

  const showConfirmationAlert = (record) => {
    MySwal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      showCancelButton: true,
      confirmButtonColor: "#00ff00",
      confirmButtonText: "Yes, delete it!",
      cancelButtonColor: "#ff0000",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        MySwal.fire({
          title: "Deleted!",
          text: "Your file has been deleted.",
          className: "btn btn-success",
          confirmButtonText: "OK",
          customClass: {
            confirmButton: "btn btn-success",
          },
        });
        deleteUserData(record);
      } else {
        MySwal.close();
      }
    });
  };
  return (
    <div>
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>User List</h4>
                <h6>Manage Your Users</h6>
              </div>
            </div>

            <div className="page-btn">
              <a
                to="#"
                className="btn btn-added"
                data-bs-toggle="modal"
                data-bs-target="#add-units"
              >
                <PlusCircle className="me-2" />
                Add New User
              </a>
            </div>
          </div>
          {/* /product list */}
          <div className="card table-list-card">
            <div className="card-body">
              <div className="table-top">
                <div className="search-set">
                  <div className="search-input">
                    <input
                      type="text"
                      placeholder="Search"
                      className="form-control form-control-sm formsearch"
                    />
                    <Link to className="btn btn-searchset">
                      <i data-feather="search" className="feather-search" />
                    </Link>
                  </div>
                </div>
              </div>

              <div className="table-responsive">
                <Table columns={columns} dataSource={userData} />
              </div>
            </div>
          </div>
          {/* /product list */}
        </div>
      </div>
      <AddUsers onSuccess={fetchUsers} />
      <EditUser
        userRole={updateUser.role}
        userId={updateUser.key}
        user={updateUser}
        onSuccess={fetchUsers}
      />
    </div>
  );
};

export default Users;
